import { Component, effect, inject, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ServiceSettingsFormsStore } from './service-settings-forms.store';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { TableColumn } from '../../../../../shared/components/kit/table/table.types';
import { ActivatedRoute, Router } from '@angular/router';
import { FormSettingsGridItemObject, FormsSettings } from '@it2go/types';
import { SERVICE_SETTINGS_FORMS_TYPE_KEY } from '@libs/types/src/services/types/service-settings-forms.type';
import { contentGlobalSuccess } from '../../../../content.error';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { Divider } from '@openng/optimus-ui/divider';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-settings-forms',
    templateUrl: './service-settings-forms.component.html',
    styleUrl: './service-settings-forms.component.scss',
    providers: [ServiceSettingsFormsStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        TableComponent,
        CheckInputComponent,
        PrimeTemplate,
        ActionButtonsComponent,
    ],
})
export class ServiceSettingsFormsComponent {
    public readonly store = inject(ServiceSettingsFormsStore);
    public readonly router = inject(Router);
    public readonly route = inject(ActivatedRoute);

    //
    // protected readonly SERVICE_SETTINGS_CONTACTS_TYPE_KEY = SERVICE_SETTINGS_CONTACTS_TYPE_KEY;
    @Input() inServiceTypeSettings: boolean = false; //else in service settings

    @ViewChild(ServiceSettingsCommonComponent) serviceSettingsCommonComponent!: ServiceSettingsCommonComponent;

    form = fb.group({});

    columns: TableColumn[] = [
        { name: 'useInThisService' },
        { name: 'name' },
        { name: 'abbreviation' },
        { name: 'description' },
        { name: 'uniqueIdentifier' },
    ];

    constructor() {
        effect(() => {
            this.loadFormSettings(routeParams.serviceId());
        });

        effect(() => {
            this.generateCheckboxes(this.store.forms());
        });
    }

    save() {
        const serviceId = routeParams.serviceId();
        if (!serviceId) return;

        const formsSettings: FormsSettings[] = [];
        Object.keys(this.form.controls ?? {}).forEach(key => {
            formsSettings.push({
                formId: +key,
                enabled: this.form.get(key)?.value ?? false,
            });
        });

        this.store.api.updateFormSettings({
            serviceId: Number(serviceId),
            formsSettings: formsSettings,
            cardSettings: {
                key: SERVICE_SETTINGS_FORMS_TYPE_KEY,
                data: this.serviceSettingsCommonComponent.getFormData(),
                serviceId: Number(serviceId),
            },
        }).then(() => {
            contentGlobalSuccess.next('common.updated');
        });
    }

    async cancel() {
        await this.router.navigate(['../../basic-information'], { relativeTo: this.route });
    }

    private loadFormSettings(serviceId: string) {
        if (serviceId) {
            this.store.api.getFormSettings(FilterBuilder.singlePage({ serviceId }));
        }
    }

    private generateCheckboxes(forms: FormSettingsGridItemObject[]) {
        if (forms) {
            this.form = fb.group({});
            forms.forEach((form: FormSettingsGridItemObject) => {
                this.form.addControl(
                    form.id.toString(),
                    fb.control<boolean>(form.enabledInService),
                );
            });
        }
    }
}
